// @flow

import styled from 'styled-components/macro';

const Head = styled.thead`
  padding: 0;
`;

export default Head;
